import * as React from "react";
const SvgFiRrHandsHoldingDiamond = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hands-holding-diamond_svg__a)">
      <path
        fill="#062147"
        d="M10.598 7.414c.39.39.902.585 1.414.585s1.024-.195 1.414-.585l1.988-1.988c.78-.78.78-2.049 0-2.829L13.426.61a2 2 0 0 0-2.828 0L8.61 2.597c-.78.78-.78 2.05 0 2.83zm1.414-5.39L14 4.011l-1.987 1.99-1.989-1.99zM24 6v10.101a7.95 7.95 0 0 1-2.343 5.657l-1.95 1.95a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l1.95-1.95A5.96 5.96 0 0 0 22 16.101v-10.1a1.001 1.001 0 0 0-2 0l-.013 8.064a2.98 2.98 0 0 1-.688 1.857l-2.578 2.685a.997.997 0 0 1-1.414.028 1 1 0 0 1-.027-1.414l2.533-2.634a.9.9 0 0 0 .188-.584v-.047a1.02 1.02 0 0 0-.255-.623 1 1 0 0 0-.687-.33.97.97 0 0 0-.72.253l-3.163 2.911A7 7 0 0 1 14 19.443v3.56a1 1 0 1 1-2 0v-3.56a5.02 5.02 0 0 0-1.615-3.68l-2.733-2.516a.97.97 0 0 0-.71-.244 1 1 0 0 0-.687.33 1 1 0 0 0-.022 1.305l2.571 2.67a1 1 0 0 1-1.441 1.387l-2.616-2.72a3.1 3.1 0 0 1-.746-1.858c-.005-.04 0-8.116 0-8.116a1.001 1.001 0 0 0-2 0v10.101c0 1.603.624 3.11 1.757 4.243l1.95 1.95a.999.999 0 1 1-1.414 1.414l-1.95-1.95a7.95 7.95 0 0 1-2.343-5.657V6c0-1.654 1.346-3 3-3s3 1.346 3 3v5.184c.266-.094.542-.164.832-.18a3 3 0 0 1 2.163.76s2.909 2.694 2.991 2.778l3.009-2.769a3 3 0 0 1 2.173-.769c.29.016.566.086.832.18V6c0-1.654 1.346-3 3-3A3.003 3.003 0 0 1 24 6"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hands-holding-diamond_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandsHoldingDiamond;
